/* global debounce */

/* Kiddoplay: scrollanimaties op de homepage */
if (document.body.classList.contains('template-index')) {
  // Voorkom dubbele animaties door het oorspronkelijke systeem.
  document.body.classList.remove('cc-animate-enabled');

  (() => {
    const main = document.querySelector('#content');
    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    if (
      !main ||
      reducedMotion.matches ||
      !('IntersectionObserver' in window) ||
      !Element.prototype.animate
    ) return;

    const registered = new WeakSet();
    const activeAnimations = new Set();

    function play(element, zoom, delay) {
      if (reducedMotion.matches || !element.isConnected) return;

      const frames = zoom
        ? [
            { opacity: 0, scale: '1.28' },
            { opacity: 1, scale: '1' }
          ]
        : [
            { opacity: 0, translate: '0 38px' },
            { opacity: 1, translate: '0 0' }
          ];

      const animation = element.animate(frames, {
        duration: zoom ? 1100 : 750,
        delay,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'backwards'
      });

      activeAnimations.add(animation);

      animation.onfinish = animation.oncancel = () => {
        activeAnimations.delete(animation);
      };
    }

    const observer = new IntersectionObserver((entries) => {
      let order = 0;

      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const target = entry.target;
        observer.unobserve(target);

        const zoom = target.classList.contains('kp-zoom-frame');
        const element = zoom ? target.querySelector('img') : target;

        if (!element) return;

        const delay = Math.min(order++ * 100, 250);

        if (zoom && !element.complete) {
          element.addEventListener('load', () => {
            const rect = target.getBoundingClientRect();

            if (rect.bottom > 0 && rect.top < window.innerHeight) {
              play(element, true, 0);
            }
          }, { once: true });
        } else {
          play(element, zoom, delay);
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px -24px 0px'
    });

    function register(element, zoom = false) {
      if (registered.has(element)) return;

      registered.add(element);

      if (zoom) {
        element.classList.add('kp-zoom-frame');
      }

      // Onderdelen boven de huidige scrollpositie niet herhalen.
      if (element.getBoundingClientRect().bottom <= 0) return;

      observer.observe(element);
    }

    function init() {
      if (reducedMotion.matches) return;

      // Foto's, inclusief de eerste grote banner.
      main.querySelectorAll(
        '.section-slideshow [data-cc-animate], ' +
        '.section-gallery .gallery__image, ' +
        '.section-hotspots .height__image'
      ).forEach((element) => register(element, true));

      // Productkaarten, titels en teksten.
      main.querySelectorAll(
        '.section-featured-collection .product-block, ' +
        '.section-featured-collection .hometitle, ' +
        '.section-rich-text [data-cc-animate], ' +
        '.section-background-video .text-overlay__text, ' +
        '.section-hotspots .text-overlay__text, ' +
        '.section-gallery .text-overlay__text'
      ).forEach((element) => register(element));
    }

    init();

    // Nieuwe secties in de Shopify-themabewerker meenemen.
    document.addEventListener('shopify:section:load', init);

    // Links direct bruikbaar houden bij toetsenbordnavigatie.
    main.addEventListener('focusin', () => {
      activeAnimations.forEach((animation) => animation.finish());
    });

    // Respecteer de voorkeur voor minder beweging.
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) {
        observer.disconnect();
        activeAnimations.forEach((animation) => animation.finish());
      }
    });
  })();
}

/* Oorspronkelijke Symmetry-animaties voor overige pagina's */
if (document.body.classList.contains('cc-animate-enabled')) {
  if ('IntersectionObserver' in window && 'MutationObserver' in window) {
    const initAnimateOnScroll = () => {
      const animatableElems = document.querySelectorAll(
        '[data-cc-animate]:not(.cc-animate-init)'
      );

      if (animatableElems.length > 0) {
        const intersectionObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (
                entry.isIntersecting &&
                !entry.target.classList.contains('cc-animate-in')
              ) {
                entry.target.classList.add('cc-animate-in');
                observer.unobserve(entry.target);
              }
            });
          }
        );

        animatableElems.forEach((elem) => {
          if (elem.dataset.ccAnimateDelay) {
            elem.style.animationDelay = elem.dataset.ccAnimateDelay;
          }

          if (elem.dataset.ccAnimateDuration) {
            elem.style.animationDuration = elem.dataset.ccAnimateDuration;
          }

          if (elem.dataset.ccAnimate) {
            elem.classList.add(elem.dataset.ccAnimate);
          }

          elem.classList.add('cc-animate-init');
          intersectionObserver.observe(elem);
        });
      }
    };

    const aosMinWidth = getComputedStyle(document.documentElement)
      .getPropertyValue('--aos-min-width') || '0';

    const mq = window.matchMedia(`(min-width: ${aosMinWidth}px)`);

    if (mq.matches) {
      initAnimateOnScroll();

      document.addEventListener('DOMContentLoaded', () => {
        const observer = new MutationObserver(
          debounce(initAnimateOnScroll, 250)
        );

        observer.observe(document.body, {
          subtree: true,
          childList: true
        });
      });
    } else {
      document.body.classList.remove('cc-animate-enabled');

      try {
        mq.addEventListener('change', (event) => {
          if (event.matches) {
            document.body.classList.add('cc-animate-enabled');
            setTimeout(initAnimateOnScroll, 100);
          }
        });
      } catch (e) {
        // In oudere browsers blijft de inhoud zichtbaar.
      }
    }
  } else {
    document.body.classList.remove('cc-animate-enabled');
  }
}